module.exports = __webpack_public_path__ + "static/media/get_ready.6d282060.mp4";